import { render, staticRenderFns } from "./StatWidget.vue?vue&type=template&id=5191d51f&scoped=true&"
import script from "./StatWidget.vue?vue&type=script&lang=js&"
export * from "./StatWidget.vue?vue&type=script&lang=js&"
import style0 from "./StatWidget.vue?vue&type=style&index=0&id=5191d51f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191d51f",
  null
  
)

export default component.exports